import axios from "axios";

console.log("process.env.ENV", process.env.ENV);



export const baseUrl = (() =>
{
  switch(process.env.ENV)
  {
  case 'prod':
    return "https://protoplan.me";
  case 'dev':
  case 'prodTest':
    return "http://localhost:" + (process.env.PORT || 3001);
  case 'test':
    return "https://protoplan-test.herokuapp.com";
  default:
    return "https://protoplan.me";
  }
})();

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true });
